import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { UserProvider } from './context/UserContext';
import { AnalyticsProvider } from './analytics/AnalyticsProvider';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import './i18n';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './index.css';
import { HeroUIProvider } from '@heroui/react';
import Clarity from '@microsoft/clarity';
import env from './config/env';
import AuthBootstrap from './auth/AuthBootstrap';

const container = document.getElementById('root');
const root = createRoot(container);
const GOOGLE_CLIENT_ID = '27196465149-ovc8keq2cj4827dcgl73mupt70nkc0nc.apps.googleusercontent.com';

// Initialize Microsoft Clarity based on environment (skip on localhost)
const hostname = window.location.hostname;
const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

if (!isLocalhost) {
  const projectId = env.APP_ENV === 'staging' ? 'un4erdved1' : 'un4ihmp7ui';
  Clarity.init(projectId);
}

root.render(
  <React.StrictMode>
    <HeroUIProvider>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <Router>
          <AuthBootstrap>
            <AnalyticsProvider>
              <UserProvider>
                <App />
              </UserProvider>
            </AnalyticsProvider>
          </AuthBootstrap>
        </Router>
      </GoogleOAuthProvider>
    </HeroUIProvider>
  </React.StrictMode>
);
